import { render } from "./AlertLabel.vue?vue&type=template&id=7ed7537a"
import script from "./AlertLabel.vue?vue&type=script&lang=js"
export * from "./AlertLabel.vue?vue&type=script&lang=js"

import "./AlertLabel.vue?vue&type=style&index=0&id=7ed7537a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__